import { ContentDivider } from '@kcd/design-system';

import { ShoebillImage } from '~/components/Image';
import DeliveryFlag from '~/domains/delivery/DeliveryFlag';
import type { OAISchema } from '~/types/openapi';

import { CutoffTimer } from './CutoffTimer';
import { MembershipBenefitBanner } from './MembershipBenefitBanner';
import { ProductPriceInfo } from './ProductPriceInfo';

function ProductInfo(
  data: OAISchema['MarketProductDetailsResponseV2'] & {
    className?: string;
  },
) {
  const {
    productName,
    mainImages,
    deliveryFlags,
    lastDeliveryCutoff,
    expectedDeliveryText,
    hasDefaultAddressRegion,
    className,
    banners,
    promotionText,
  } = data;

  return (
    <section className={className}>
      <div className="relative h-[100vw] max-h-[768px]">
        <ShoebillImage
          priority
          src={mainImages[0]}
          alt={`${productName!}`}
          layout="fill"
          objectFit="contain"
          fetchPriority="high"
        />

        <div className="absolute inset-x-0 bottom-0 flex w-full flex-col items-center">
          {banners.map((banner) => {
            return (
              <MembershipBenefitBanner
                description={banner.description}
                type={banner.type}
                key={banner.type}
              />
            );
          })}
        </div>
      </div>

      <div className="mx-20 pt-16">
        <DeliveryFlag flags={deliveryFlags} />
        <CutoffTimer
          lastDeliveryCutoff={lastDeliveryCutoff}
          expectedDeliveryText={expectedDeliveryText}
          hasDefaultAddressRegion={hasDefaultAddressRegion}
        />
        <ContentDivider className="my-8" />
        <div className="flex flex-col gap-8">
          <div>
            <h2 className="mt-16 text-paragraph typo-title100-semibold">
              {productName}
            </h2>
            {promotionText && (
              <p className="text-red-600 typo-paragraph100-regular">
                {promotionText}
              </p>
            )}
          </div>
          <ProductPriceInfo data={data} />
        </div>
      </div>
    </section>
  );
}

export default ProductInfo;
